module.exports = __webpack_public_path__ + "static/media/superface_3D_1.5dfdddee.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/superface_3D_1.png
// module id = 564
// module chunks = 0